import { axios } from '../axios';

class GamificationService {
  list(body) {
    return axios.post('/gamification-new/point/list', body);
  }

  post(body) {
    return axios.post('/gamification-new/point', body);
  }

  put(body) {
    return axios.put(`/gamification-new/point/${body.id}`, body);
  }

  delete(id) {
    return axios.delete(`/gamification-new/point/${id}`);
  }
}

export default new GamificationService();
